var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystemAdminIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.1,29.6H4.6c-.9,0-1.6-.7-1.6-1.6v-13.5c0-.9.7-1.6,1.6-1.6h23.5c.9,0,1.6.7,1.6,1.6v13.5c0,.9-.7,1.6-1.6,1.6ZM4.6,14.1c-.2,0-.4.2-.4.4v13.5c0,.2.2.4.4.4h23.5c.2,0,.4-.2.4-.4v-13.5c0-.2-.2-.4-.4-.4H4.6Z",
    style: {
      fill: "#0194d3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.6,
    y: 24.8,
    width: 25.4,
    height: 1.2,
    style: {
      fill: "#0194d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7,33.2h-6.6c-.2,0-.4,0-.5-.2-.1-.2-.1-.4,0-.5l1-3.3,1.2.4-.8,2.5h5l-.8-2.5,1.2-.4,1.1,3.3c0,.2,0,.4,0,.6s-.3.3-.5.3Z",
    style: {
      fill: "#0194d3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 27.2,
    r: 0.9,
    style: {
      fill: "#0194d3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.1,12.3c.3-.5,1.4-1,2.3-1.1,2.1-.3,4,1.5,4.3,3.7.3,1.6-.8,3.7-2.3,4.2",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23.1 10.2 24.2 7.9 26 9.3 27.4 8.8 28.3 6.8 31.2 7.3 31.7 9.4 32.7 10.3 34.7 9.6 36.5 12.1 34.8 13.8 35.2 15.3 37 16 36.4 19 34.6 19.1 33.7 20.4 34.1 22.1 33 23.7 31 22.2",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAdminIcon);
export default __webpack_public_path__ + "static/media/system-admin-icon.04e1ea1c548f2a679811e8a51f2d5c46.svg";
export { ForwardRef as ReactComponent };